const button_size_guide = document.querySelector('.button-size_guide');
if (button_size_guide) button_size_guide.addEventListener('click', () => window.clickSizeGuide())

window.clickSizeGuide = function () {
        document.querySelector('.size-quide__wrap').classList.add('guide__open');
        document.querySelector('body').classList.add('size-open', 'hidden');

        function closeSizeGuide() {
            document.querySelector('.size-quide__wrap').classList.remove('guide__open');
            document.querySelector('body').classList.remove('size-open', 'hidden');
        }

        document.querySelector('.guide__backdrop').addEventListener('click', closeSizeGuide)
        document.querySelector('.guide-chart__close').addEventListener('click', closeSizeGuide)

        document.querySelector('.guide-size-open-select').addEventListener('click', () => {
            document.querySelector('.guide-size-wrap').classList.add('open')
        })

        document.querySelectorAll('.guide-size-wrap li').forEach(el => {
            el.addEventListener( 'click',e => {
                document.querySelector('.guide-imgs img').setAttribute('src', e.target.dataset.url)
                document.querySelector('.guide-size-wrap').classList.remove('open')
                document.querySelector('.guide-size-open-select span').innerText = e.target.innerText
            })
        })
}

const button_size_chart = document.querySelector('.button-size_chart');
if (button_size_chart) {
    button_size_chart.addEventListener('click', () => {
        document.querySelector('.size-chart-modal__content').classList.add('open');
        setTimeout(function () {
            document.querySelector('.size-chart-modal__content').classList.add('loaded');
        }, 250);
        document.querySelector('body').classList.add('size-open', 'hidden');

        function closeSizeChart() {
            document.querySelector('.size-chart-modal__content').classList.remove('loaded');
            setTimeout(function () {
                document.querySelector('.size-chart-modal__content').classList.remove('open');
            }, 200);
            document.querySelector('body').classList.remove('size-open', 'hidden');
        }

        document.querySelector('.bg-section_cart-size').addEventListener('click', closeSizeChart)
        document.querySelector('.size-chart__close').addEventListener('click', closeSizeChart)

    })

    const cm_unit = 2.54;
    const inch_unit = 0.393701;
    const category_inputs = document.querySelectorAll('.js-sc-category-inputs input');
    const table_sections = document.querySelectorAll('.js-sc-table-section');
    const unit_form_inputs =  document.querySelectorAll('.js-sc-unit-form input');

    unit_form_inputs.forEach(inp => {
        inp.addEventListener('change', (inp_)=> {
            const unit_name = inp_.target.value;
            let title = document.querySelector('.unit-converter__header-unit').getAttribute("data-sc-" + unit_name  + "-title");
            document.querySelector('.unit-converter__header-unit').innerText = title;

            document.querySelectorAll('.js-sc-unit').forEach(sc_unit => {
                sizeUnitConverter(sc_unit, unit_name);
            })
        })
    })

    category_inputs.forEach(category_input => {
        category_input.addEventListener('change', (category_) => {
            categorySwitcher(category_.target.value);
        })

    })

    function categorySwitcher(category) {
        table_sections.forEach( table_section => {
            var $table = table_section;
            var $table_body = $table.querySelector('tbody');
            var table_filters = $table.getAttribute('data-sc-section-filters').split(',');
            var $row_filters = $table.getAttribute('data-hide-row').split(',');

            // Resets the filter functionality
            $table.style.display = 'none';
            $table_body.querySelector('tr').style.display = 'table-row';

            table_filters.forEach(function (table_filter) {
                if (category == table_filter) {
                    $table.style.display = 'block';

                    $row_filters.forEach(function (row_filter) {
                        var filter_array = row_filter.split(':');
                        var category_name  = filter_array[0];
                        var row_name = filter_array[1];

                        // Hide data of a table depending on the category
                        if (category == category_name) {
                            $table_body.querySelector('tr[data-row-name="' + row_name  + '"]').style.display = 'none';
                        }
                    });
                }
            });
        });
    }

    function sizeUnitConverter($element, unit_name) {
        var table_data = $element.innerText.split('-');
        var new_data = '';

        table_data.forEach(function (data,i) {

            // Will not run if the data is not a number
            if (isNumeric(data)) {
                var unit = parseFloat(data); // table data
                var cm_to_inch = parseFloat(unit * inch_unit).toFixed(1).toString().split('.'); // Makes an array of integers
                var inch_to_cm = parseFloat(unit * cm_unit).toFixed(1).toString().split('.'); // Makes an array of integers
                var decimal_point = '.';
                var separator = '-'
                var new_unit = '';

                if (unit_name == 'inch') {

                    // Remmoves trailing zeros from the number
                    if (cm_to_inch[1] == 0) {
                        cm_to_inch[1] = '';
                        decimal_point = ''
                    }

                    new_unit = cm_to_inch[0] + decimal_point + cm_to_inch[1]
                } else if (unit_name == 'cm') {

                    // Remmoves trailing zeros from the number
                    if (inch_to_cm[1] == 0) {
                        inch_to_cm[1] = '';
                        decimal_point = '';
                    }

                    new_unit = inch_to_cm[0] + decimal_point + inch_to_cm[1];
                }

                if (i >= table_data.length - 1) {
                    separator = '';
                }
                new_data += new_unit + separator;
                $element.innerText = new_data;
            }
        });
    }

    function isNumeric(value) {
        return typeof value === 'number' && isFinite(value) ||
            typeof value === 'string' && value !== '' && !isNaN(parseFloat(value)) && isFinite(parseFloat(value));
    }

}